import router from '@/router'
import { store } from '@/store'

export const sessionCheck = async (): Promise<boolean> => {
  if (await store.dispatch('sessionCheck')) {
    return true
  }
  router.push('/')
  return false
}
